import Vue from 'vue';
import Vuex from 'vuex';

import { isEmptyObject } from '@/utils.js';

Vue.use(Vuex);

/**
 * 全局AccessToken在sessionStorage中存储Key
 */
const ACCESS_TOKEN_STORE_KEY = '$ACCESS_TOKEN';

/**
 * 当前登录用户访问状态在sessionStorage中存储Key
 */
const USER_ACCESS_STATE_KEY = '$USER_ACCESS_STATE';

const IS_ORG_SELF_KEY = '$IS_ORG_SELF';

const store = new Vuex.Store({
    state: {
        /**
         * 登录后的访问凭证
         */
        accessToken: {},
        /**
         * 登录用户的所有数据已经加载完毕?
         */
        loginUserAllDataReady: false,
        /**
         * 登录用户的所有数据
         */
        loginUserAllData: { loginUser: {}, userNavMenuList: [], defaultActiveMenu: '' },
        /**
         * 当前登录用户访问状态
         * 包括属性{userName, lastAccessWebUrl, lastAccessApiUrl, lastAccessTime, secondLastAccessApiUrl, secondLastAccessTime}
         */
        userAccessState: {},
        /**
         * 是否仅控制本机构人员
         */
        isOrgSelf: false,
    },
    getters: {
        /**
         * JWT访问令牌
         * (使用getter方法，不缓存模式)
         * this.$store.getters.getAccessToken()
         */
        getAccessToken: (state) => () => {
            if (isEmptyObject(state.accessToken)) {
                state.accessToken = JSON.parse(localStorage.getItem(ACCESS_TOKEN_STORE_KEY)) || {};
            }
            return state.accessToken;
        },
        /**
         * 当前登录用户访问状态
         * (使用getter方法，不缓存模式)
         * this.$store.getters.getUserAccessState()
         */
        getUserAccessState: (state) => () => {
            if (isEmptyObject(state.userAccessState)) {
                state.userAccessState = JSON.parse(localStorage.getItem(USER_ACCESS_STATE_KEY)) || {};
            }
            return state.userAccessState;
        },
        isOrgSelf: (state) => {
            if (!state.isOrgSelf) {
                let isOrgSelf = localStorage.getItem(IS_ORG_SELF_KEY);
                state.isOrgSelf = isOrgSelf ? JSON.parse(isOrgSelf) : false;
            }
            return state.isOrgSelf;
        }
    },
    mutations: {
        updateAccessToken(state, newToken) {
            newToken = newToken ? newToken : {};
            state.accessToken = newToken;
            localStorage.setItem(ACCESS_TOKEN_STORE_KEY, JSON.stringify(newToken));
        },
        updateLoginUserAllData(state, allData) {
            state.loginUserAllData = allData;
        },
        setLoginUserAllDataReady(state) {
            state.loginUserAllDataReady = true;
        },
        updateUserAccessState(state, newState) {
            newState = newState ? newState : {};
            state.userAccessState = newState;
            localStorage.setItem(USER_ACCESS_STATE_KEY, JSON.stringify(newState));
        },
        updateOrgSelf(state, isOrgSelf) {
            state.isOrgSelf = isOrgSelf;
            localStorage.setItem(IS_ORG_SELF_KEY, JSON.stringify(isOrgSelf));
        }
    },
    actions: {
        executeUpdateAccessToken(context, newToken) {
            context.commit('updateAccessToken', newToken);
        },
        executeClearLoginUserAllData(context) {
            context.commit('updateLoginUserAllData', { loginUser: {}, userNavMenuList: [] });
            context.commit('updateOrgSelf', false);
        },
        executeUpdateLoginUserAllData(context, allData) {
            context.commit('updateLoginUserAllData', allData);
            context.commit('updateOrgSelf', allData.isOrgSelf);
            context.commit('setLoginUserAllDataReady'); //标记为已加载
        },
        executeUpdateUserAccessState(context, newState) {
            context.commit('updateUserAccessState', newState);
        },
        resetStore4Logout(context) {
            context.commit('updateAccessToken', {});
            context.commit('updateLoginUserAllData', { loginUser: {}, userNavMenuList: [] });
            context.commit('updateOrgSelf', false);
            context.commit('updateUserAccessState', {});
        }
    }
});

export default store;